export default __webpack_public_path__ + "assets/images/90f166b03e21dea99fbde92669f8e967.png";